import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class WsOrdenService {

  private endpoint = `/api/WsOrden`;
  private apiUrlOlva = `http://ws.olvacourier.com:8080`;
  private codOlva = 'CIP';

  constructor(private http: HttpClient, private handler: HttpBackend) { }

  getAll(): Observable<any[]> {
    const headers = { context: '.tab-content' };
    return this.http.get<[]>(`${this.endpoint}/listar`, { headers });
  }

  get(IdOrden: number): Observable<any> {
    const headers = { context: '.load-detalle' };
    return this.http.get<any>(`${this.endpoint}/${IdOrden}`, { headers });
  }

  tracking(codigo: number): Observable<any> {
    const headers = { context: '.modal-body' };
    return this.http.get<any>(`${this.endpoint}/seguimiento/${this.codOlva}/${codigo}`, { headers });
  }

  trackingByRemito(emision: string, remito: string): Observable<any> {
    const headers = { context: '.modal-body' };
    return this.http.get<any>(`${this.endpoint}/seguimiento-remito/${emision}/${remito}`, { headers });
  }

  acuse(codigo: any): Observable<any> {
    // const headers = { 'Content-Type': 'text/plain' };
    const http = new HttpClient(this.handler);
    return http.get(`${this.apiUrlOlva}/bbvaimportar/resources/imagen/guia/${this.codOlva}/${codigo}`, { responseType: 'text' });
  }

}
